'use strict';

module.exports = require('./lib')



//////////////////
// WEBPACK FOOTER
// ./~/promise/index.js
// module id = 3134
// module chunks = 3